<template>
    <div>
        <b-modal :active.sync="isOpen" :width="1200" scroll="keep" @close="closeModal">
            <div class="modal-card" style="width: auto;">
                <header class="modal-card-head">
                    <p class="modal-card-title">Producten bewerken</p>
                </header>
                <section class="modal-card-body" style="border-radius: 0;">
                    <ContractsRecordProducts
                        ref="ContractsRecordProducts_products"
                        type="products"
                        @passProducts="passProducts"
                        :onlyModal="true"
                        mode="edit"
                        :record="localRecord"
                    />

                    <!-- Discount Modal -->
                    <discount-modal
                        :is-open="showDiscountModal"
                        :product-price="currentProductPrice"
                        :existing-discounts="currentProductDiscounts"
                        :single-invoice-mode="true"
                        @close="showDiscountModal = false"
                        @apply="applyDiscount"
                        @remove="removeDiscount"
                    />

                    <b-notification v-if="record.customer && record.customer.type == 'business'" type="is-info" aria-close-label="Sluiten">
                        <strong>Let op:</strong> Bij zakelijke klanten worden prijzen exclusief BTW ingevoerd. BTW wordt toegevoegd bij het totaalbedrag na het opslaan.
                    </b-notification>

                    <b-notification v-if="record.customer && record.customer.type == 'foundation'" type="is-info" aria-close-label="Sluiten">
                        <strong>Let op:</strong> klant betreft een stichting, BTW wordt niet getoond op de factuur.
                    </b-notification>

                    <b-table
                        :data="localRecord.products"
                        :striped="true"
                        :loading="loading"
                        :mobile-cards="true"
                        class="deposit-table"
                    >
                        <template>
                            <b-table-column v-slot="product" field="name" label="Product" width="200">
                                <b-input v-model="product.row.name"></b-input>
                            </b-table-column>

                            <b-table-column v-slot="product" field="btw" label="BTW %" width="100">
                                <b-input
                                    type="number"
                                    min="0"
                                    max="100"
                                    v-model="product.row.btw"
                                ></b-input>
                            </b-table-column>

                            <b-table-column v-slot="product" field="amount" label="Aantal" width="100">
                                <b-input type="number" min="1" v-model="product.row.amount"></b-input>
                            </b-table-column>

                            <b-table-column v-slot="product" field="deposit" label="Borg" width="100">
                                <b-input
                                    v-model="product.row.deposit"
                                    min="0"
                                    type="number"
                                    step="0.01"
                                />
                            </b-table-column>

                            <b-table-column v-slot="product" field="price" label="Totaal" width="100">
                                <b-input
                                    v-model="product.row.price"
                                    min="0"
                                    type="number"
                                    step="0.01"
                                />
                            </b-table-column>

                            <b-table-column v-slot="product" label="Korting" width="100">
                                <b-button
                                    type="is-info"
                                    icon-left="percent"
                                    @click="openDiscountModal(product.row)"
                                    :outlined="!hasDiscount(product.row.id) && (!product.row.discount_value || product.row.discount_value == 0)"
                                    size="is-small"
                                >
                                    {{ getDiscountDisplay(product.row) }}
                                </b-button>
                            </b-table-column>

                            <b-table-column v-slot="product" numeric width="0">
                                <b-tooltip label="Verwijder product" position="is-left">
                                    <b-button icon-right="times" type="is-danger" @click="removeProduct(product.row.id)"></b-button>
                                </b-tooltip>
                            </b-table-column>
                        </template>
                        <template #footer>
                            <table class="text-right deposit-table-footer">
                                <tr>
                                    <th>Subtotaal (ex. BTW)</th>
                                    <th width="150">€&nbsp;{{ !_.isNaN(subTotal) ? number_format(subTotal) : '-' }}</th>
                                </tr>
                                <tr>
                                    <th>Inbegrepen BTW:</th>
                                    <th width="150">€&nbsp;{{ !_.isNaN(btwTotal) ? number_format(btwTotal) : '-' }}</th>
                                </tr>
                                <tr v-if="totalDiscountAmount > 0" style="color: #d9534f;">
                                    <th>Totale korting{{ record.customer && record.customer.type == 'business' ? ' (ex. BTW)' : '' }}:</th>
                                    <th width="150" class="has-text-danger">- €&nbsp;{{ number_format(totalDiscountAmount) }}</th>
                                </tr>
                                <tr v-if="record.customer && record.customer.type == 'business'" >
                                    <th class="text-info">Totaal (incl. BTW):</th>
                                    <th width="150">€&nbsp;{{ !_.isNaN(totalPrice) ? number_format(totalPrice) : '-' }}</th>
                                </tr>
                                <tr v-else>
                                    <th>Totaal:</th>
                                    <th width="150">€&nbsp;{{ !_.isNaN(totalPrice) ? number_format(totalPrice) : '-' }}</th>
                                </tr>
                            </table>
                        </template>
                    </b-table>

                    <b-button @click="addProduct" type="is-primary">Product toevoegen</b-button>
                    <b-button @click="$refs['ContractsRecordProducts_products'].showModal(localRecord.products)" type="is-primary">Product zoeken</b-button>
                </section>
                <footer class="modal-card-foot">
                    <b-button type="is-light" @click="closeModal" :disabled="saving">Annuleren</b-button>
                    <b-button type="is-success" @click="confirmSave" :loading="saving">Opslaan</b-button>
                </footer>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue'
import ContractsRecordProducts from '@/vue/contracts/ContractsRecordProducts'
import DiscountModal from '@/vue/discounts/DiscountModal'
import filtersMixin from '@/mixins/filterMixins'
import InvoiceProductsMixin from '@/mixins/InvoiceProductsMixin'

export default {
    name: 'EditProducts',

    components: {
        ContractsRecordProducts,
        DiscountModal
    },

    mixins: [filtersMixin, InvoiceProductsMixin],

    props: {
        record: {
            type: Object,
            required: true
        },
        isOpen: {
            type: Boolean,
            required: true,
            default: false
        }
    },

    data() {
        return {
            localRecord: {
                products: [],
                customer: null,
                organisation: null
            },
            loading: false,
            saving: false,
            showDiscountModal: false,
            currentProductPrice: 0,
            currentProductDiscounts: [],
            currentProductRow: null,
            productDiscounts: {} // Store discounts per product ID
        }
    },

    computed: {
        subTotal() {
            if(!_.has(this, 'localRecord.products')) return false;

            let price = 0
            _.each(this.localRecord.products, (product) => {
                const isBusinessCustomer = this.record && _.has(this.record, 'customer') && this.record.customer && this.record.customer.type == 'business'
                const discount = this.getProductDiscountAmount(product);

                if (product.price && product.btw) {
                    if (isBusinessCustomer) {
                        // For business customers, product.price is now the base price (ex. BTW) after initialization
                        const basePrice = parseFloat(product.price) * product.amount;
                        price += basePrice - discount;
                    } else {
                        // For normal customers, product.price is the original price including BTW
                        // Calculate discounted total first, then extract base price
                        const productTotal = parseFloat(product.price) * product.amount;
                        const discountedTotal = productTotal - discount;
                        const basePrice = discountedTotal / (1 + Number(product.btw) / 100);
                        price += basePrice;
                    }
                }
            })

            return price
        },

        btwTotal() {
            if(!_.has(this, 'localRecord.products')) return false;
            let price = 0

            _.each(this.localRecord.products, (product) => {
                const isBusinessCustomer = this.record && _.has(this.record, 'customer') && this.record.customer && this.record.customer.type == 'business'
                const discount = this.getProductDiscountAmount(product);

                if (isBusinessCustomer) {
                    const basePrice = parseFloat(product.price) * product.amount;
                    const discountedBase = basePrice - discount;
                    price += (discountedBase * product.btw / 100)
                } else {
                    // Calculate BTW on the discounted price
                    const totalPrice = parseFloat(product.price) * product.amount;
                    const discountedPrice = totalPrice - discount;
                    price += discountedPrice - (discountedPrice / (1 + Number(product.btw) / 100))
                }
            })

            return price
        },

        totalPrice() {
            if(!_.has(this, 'localRecord.products')) return false;
            let price = 0

            _.each(this.localRecord.products, (product) => {
                const isBusinessCustomer = this.record && _.has(this.record, 'customer') && this.record.customer && this.record.customer.type == 'business'
                const discount = this.getProductDiscountAmount(product);

                if(isBusinessCustomer){
                    const basePrice = parseFloat(product.price) * product.amount;
                    const discountedBase = basePrice - discount;
                    const btwAmount = discountedBase * product.btw / 100;
                    price += discountedBase + btwAmount + (parseFloat(product.deposit) * product.amount);
                } else {
                    price += (parseFloat(product.price) * product.amount) + (parseFloat(product.deposit) * product.amount) - discount;
                }
            })

            return price
        },

        totalDiscountAmount() {
            let total = 0;
            this.localRecord.products.forEach(product => {
                total += this.getProductDiscountAmount(product);
            });
            return total;
        },
    },

    watch: {
        isOpen(newVal) {
            if (newVal) {
                this.initializeLocalRecord();
            }
        },

        'localRecord.products': {
            handler() {
                this.$forceUpdate()
            },
            deep: true
        }
    },

    methods: {
        initializeLocalRecord() {
            // Deep clone the products
            this.localRecord.products = JSON.parse(JSON.stringify(this.record.invoice_products || []));
            this.localRecord.customer = this.record.customer;
            this.localRecord.organisation = this.record.organisation;

            const isBusinessCustomer = this.record && _.has(this.record, 'customer') && this.record.customer && this.record.customer.type == 'business';

            // Initialize product discounts from existing discount data
            this.productDiscounts = {};
            this.localRecord.products.forEach(product => {
                // For business customers, extract base price from stored price (which includes BTW)
                // Stored price = basePrice + btw_price, so basePrice = price - btw_price
                if (isBusinessCustomer && product.btw_price !== undefined && product.btw_price !== null) {
                    // Extract base price: stored price includes BTW, so subtract btw_price
                    const storedPrice = parseFloat(product.price) || 0;
                    const btwPrice = parseFloat(product.btw_price) || 0;
                    product.price = storedPrice - btwPrice;
                }

                if (product.discount_type && product.discount_value) {
                    Vue.set(this.productDiscounts, product.id, [{
                        type: product.discount_type,
                        value: product.discount_value,
                        description: product.discount_description || null
                    }]);

                    // If discount exists and org_price is set, use org_price to restore the original price
                    // This allows the user to see and edit the original price before discount
                    if (product.org_price) {
                        if (isBusinessCustomer) {
                            // For business customers, org_price is the original TOTAL (basePrice + original BTW)
                            // Extract original base price: basePrice = org_price / (1 + btw/100)
                            const orgPriceTotal = parseFloat(product.org_price) || 0;
                            const btw = parseFloat(product.btw) || 0;
                            const originalBasePrice = orgPriceTotal / (1 + btw / 100);
                            product.price = originalBasePrice;
                        } else {
                            // For normal customers, org_price is the original price (includes BTW)
                            // Use it directly since the UI shows price including BTW for normal customers
                            product.price = parseFloat(product.org_price) || 0;
                        }
                    }
                }

                // Ensure numeric values
                product.amount = product.amount || 1;
                product.price = parseFloat(product.price) || 0;
                product.deposit = parseFloat(product.deposit) || 0;
                product.btw = parseFloat(product.btw) || 0;
            });
        },

        passProducts(obj) {
            // Replace all products with the selected ones from product search
            const products = obj.records.map(product => {
                return {
                    ...product,
                    amount: product.amount || 1,
                    type: 'product',
                    contract: null,
                    once: 1,
                    product: product.id,
                    // Generate temporary ID for new products
                    id: Math.floor(100000000 + Math.random() * 900000000),
                    isNew: true
                }
            });

            // Replace products array instead of pushing
            this.$set(this.localRecord, 'products', products);
        },

        removeProduct(productId) {
            // Check if this will be the last product
            if (this.localRecord.products.length === 1) {
                this.localRecord.products = [];
                // Add empty product row
                this.addProduct();
                return;
            }

            const products = _.remove(this.localRecord.products, (x) => {
                return x.id != productId
            })

            this.$set(this.localRecord, 'products', products)
        },

        addProduct() {
            const product = {
                id: Math.floor(100000000 + Math.random() * 900000000), // random ID for deletion
                amount: 1,
                btw: '21.00',
                deposit: '0.00',
                name: '',
                price: '0.00',
                once: 1,
                organisation: this.record.organisation,
                type: 'product',
                product: null,
                isNew: true
            }

            this.localRecord.products.push(product)
        },

        openDiscountModal(row) {
            this.currentProductRow = row
            const isBusinessCustomer = this.record && _.has(this.record, 'customer') && this.record.customer && this.record.customer.type == 'business'

            // For discount calculation, we need the total price (including BTW for business customers)
            let priceToUse = parseFloat(row.org_price || row.price) || 0

            // For business customers, if we have org_price, it might include BTW, otherwise calculate total from base price
            if (isBusinessCustomer) {
                if (row.org_price) {
                    // org_price might include BTW (from stored price), use it as-is
                    priceToUse = parseFloat(row.org_price) || 0
                } else {
                    // Calculate total price from base price: basePrice + (basePrice * btw / 100)
                    const basePrice = parseFloat(row.price) || 0
                    const btw = parseFloat(row.btw) || 0
                    priceToUse = basePrice + (basePrice * btw / 100)
                }
            }

            this.currentProductPrice = priceToUse
            this.currentProductDiscounts = this.productDiscounts[row.id] || []
            this.showDiscountModal = true
        },

        applyDiscount(discountsData) {
            if (this.currentProductRow) {
                Vue.set(this.productDiscounts, this.currentProductRow.id, discountsData.discounts || [])
                this.$forceUpdate()
            }
            this.showDiscountModal = false
        },

        removeDiscount() {
            if (this.currentProductRow) {
                Vue.delete(this.productDiscounts, this.currentProductRow.id)
                // Also remove discount fields from the product
                this.currentProductRow.discount_type = null
                this.currentProductRow.discount_value = null
                this.currentProductRow.discount_description = null
                this.$forceUpdate()
            }
            this.showDiscountModal = false
        },

        hasDiscount(productId) {
            return this.productDiscounts[productId] && this.productDiscounts[productId].length > 0
        },

        getDiscountDisplay(row) {
            const discounts = this.productDiscounts[row.id]

            if (!discounts || discounts.length === 0) {
                return 'Korting'
            }

            const discount = discounts[0]
            if (discount.type === 'percentage') {
                return `${discount.value}%`
            }
            return `€${discount.value}`
        },

        getProductDiscountAmount(product) {
            const discounts = this.productDiscounts[product.id];
            if (!discounts || discounts.length === 0 || !discounts[0].value) {
                return 0;
            }

            const discount = discounts[0];
            const isBusinessCustomer = this.record && _.has(this.record, 'customer') && this.record.customer && this.record.customer.type == 'business';

            // Use current price for discount calculation (user may have edited it)
            // For business customers, product.price is the base price (ex. BTW)
            // For normal customers, product.price is the total price (includes BTW)
            let price = parseFloat(product.price) || 0;

            // If price matches org_price (hasn't been edited), we could use org_price,
            // but since we're using current price anyway, we can just use product.price
            // The current price is already set correctly in initializeLocalRecord

            const amount = product.amount || 1;

            if (discount.type === 'percentage') {
                return (price * amount) * (discount.value / 100);
            } else {
                return Math.min(discount.value * amount, price * amount);
            }
        },

        number_format(val, decimals = 2) {
            val = parseFloat(val)
            return val.toFixed(decimals)
        },

        confirmSave() {
            // Validate products
            const invalidProducts = this.localRecord.products.filter(p => !p.name || p.name.trim() === '');
            if (invalidProducts.length > 0) {
                this.$buefy.toast.open({
                    message: 'Alle producten moeten een naam hebben.',
                    type: 'is-danger'
                });
                return;
            }

            // Show confirmation dialog
            this.$buefy.dialog.confirm({
                title: 'Producten opslaan',
                message: 'Weet je zeker dat je de wijzigingen wilt opslaan? De factuur totalen worden herberekend en openstaande betalingen worden aangepast.',
                confirmText: 'Opslaan',
                cancelText: 'Annuleren',
                type: 'is-warning',
                hasIcon: true,
                onConfirm: () => this.saveProducts()
            });
        },

        saveProducts() {
            this.saving = true;

            // Apply discounts to products
            const productsToSave = this.localRecord.products.map(product => {
                const discounts = this.productDiscounts[product.id];
                if (discounts && discounts.length > 0) {
                    return {
                        ...product,
                        discount_type: discounts[0].type,
                        discount_value: discounts[0].value,
                        discount_description: discounts[0].description || null
                    };
                }
                return product;
            });

            axios.post(`/api/invoices/${this.record.id}/update-products`, {
                products: productsToSave
            }, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.$buefy.toast.open({
                    message: 'Producten succesvol bijgewerkt',
                    type: 'is-success'
                });
                this.$emit('saved');
                this.closeModal();
            }).catch((error) => {
                const message = error.response?.data?.error || 'Opslaan mislukt';
                this.$buefy.toast.open({
                    message: message,
                    type: 'is-danger'
                });
            }).finally(() => {
                this.saving = false;
            });
        },

        closeModal() {
            this.$emit('close');
        }
    }
}
</script>

<style scoped>
.deposit-table-footer {
    width: 100%;
    margin-top: 1rem;
}

.deposit-table-footer th {
    padding: 0.5rem;
    text-align: right;
}
</style>
